import { Signal } from '@angular/core';

export abstract class AuthService {
  abstract isAuthenticated: Signal<boolean>;

  abstract logIn(language: string, successRedirect: string, mode?: string): void;
  abstract logOut(): void;
}
